import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import team from "../assets/images/team.png";
import * as React from "react";

const Team = () => {
  return (

    <div className="Example">
      <AppBarh/>
      <Box
         sx={{
                    background: '#EFF1F4',
                    marginTop: '10px',
                    padding: { xs: '0px', sm: '0px', md: '20px', lg: '50px', xl: '20px' },
                    // padding: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
       <Typography variant={'h4'} sx={{ color: '#091D3D'}} fontWeight={'700'} align={'center'}>
                  Our Team
              </Typography>
      <img
        src={team}
        alt="Team Image"
        style={{ width: '100%', height: 'auto', marginTop: '10px' }}
      />

      </Box>
      <Footer/>
    </div>

  );
};

export default Team;